import { useAllProgramContent, useWorkflows } from '@cibo/programs'

export const useEnrollments = () => {
  const enrollments = useWorkflows(0, 1000, {
    benchmark: ['enrollment'],
    includeEngagementWorkflows: true,
  })
  const content = useAllProgramContent()

  const sortedEnrollmentsWithContent =
    enrollments.data?.items
      .map(item => ({
        ...item,
        programContent: content.data?.find(c => c.programId === item.programId)?.content,
      }))
      .sort((a, b) => {
        if (a.updatedAt > b.updatedAt) return -1
        if (a.updatedAt < b.updatedAt) return 1
        return 0
      }) || []

  return { sortedEnrollmentsWithContent, ...enrollments }
}
